var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "b-modal",
        {
          ref: "projectsManagerModalRef",
          attrs: {
            id: "projectsManagerModalRef",
            "hide-footer": true,
            title: "Selecione um projeto para replicar os dados de Gestor",
            size: "lg",
            "hide-header": false
          }
        },
        [
          _c("div", { staticClass: "modal-projects-list" }, [
            _vm.loadingProjects
              ? _c("div", [
                  _c("h6", [_vm._v("Aguarde, carregando projetos...")])
                ])
              : _c(
                  "ul",
                  _vm._l(_vm.projects, function(p) {
                    return _c("li", { key: p.ProjectId }, [
                      p.Manager
                        ? _c(
                            "a",
                            {
                              attrs: { href: "#" },
                              on: {
                                click: function($event) {
                                  $event.stopPropagation()
                                  $event.preventDefault()
                                  return _vm.selectProjectManager(p)
                                }
                              }
                            },
                            [
                              _c("span", [
                                _vm._v(
                                  _vm._s(p.Info ? p.Info.title : "Sem Título")
                                )
                              ]),
                              _vm._v(" "),
                              _c("p", [
                                _vm._v(
                                  "Nome Completo: " + _vm._s(p.Manager.name)
                                )
                              ]),
                              _vm._v(" "),
                              _c("p", [
                                _vm._v(
                                  "Organização: " +
                                    _vm._s(p.Manager.organization)
                                )
                              ])
                            ]
                          )
                        : _c(
                            "a",
                            {
                              attrs: { href: "#" },
                              on: {
                                click: function($event) {
                                  $event.stopPropagation()
                                  $event.preventDefault()
                                  return _vm.showAlert()
                                }
                              }
                            },
                            [
                              _c("span", [
                                _vm._v(
                                  _vm._s(p.Info ? p.Info.title : "Sem Título")
                                )
                              ]),
                              _vm._v(" "),
                              _c("p", [
                                _vm._v("Projeto não possui gestor cadastrado.")
                              ])
                            ]
                          )
                    ])
                  }),
                  0
                )
          ])
        ]
      ),
      _vm._v(" "),
      _vm.projects && _vm.projects.length > 0
        ? _c("div", { staticClass: "row" }, [
            _c("div", { staticClass: "col-md-8" }),
            _vm._v(" "),
            _c("div", { staticClass: "col-md-4" }, [
              _c(
                "button",
                {
                  directives: [
                    {
                      name: "b-modal",
                      rawName: "v-b-modal.projectsManagerModalRef",
                      modifiers: { projectsManagerModalRef: true }
                    }
                  ],
                  staticClass: "btn"
                },
                [_vm._v("Copiar de outro projeto")]
              )
            ])
          ])
        : _vm._e(),
      _vm._v(" "),
      _c("div", { staticClass: "row" }, [
        _vm._m(0),
        _vm._v(" "),
        _c("div", { staticClass: "col-md-8" }, [
          _c("form", [
            _c("div", { staticClass: "row" }, [
              _c("div", { staticClass: "form-group col-sm" }, [
                _c("label", [_vm._v("Nome completo")]),
                _vm._v(" "),
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.name,
                      expression: "name"
                    }
                  ],
                  staticClass: "form-control",
                  attrs: { type: "text" },
                  domProps: { value: _vm.name },
                  on: {
                    input: function($event) {
                      if ($event.target.composing) {
                        return
                      }
                      _vm.name = $event.target.value
                    }
                  }
                })
              ])
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "row" }, [
              _c("div", { staticClass: "form-group col-sm" }, [
                _c("label", [_vm._v("Nome da organização")]),
                _vm._v(" "),
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.organization,
                      expression: "organization"
                    }
                  ],
                  staticClass: "form-control",
                  attrs: { type: "text" },
                  domProps: { value: _vm.organization },
                  on: {
                    input: function($event) {
                      if ($event.target.composing) {
                        return
                      }
                      _vm.organization = $event.target.value
                    }
                  }
                })
              ])
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "row" }, [
              _c("div", { staticClass: "form-group col-sm" }, [
                _c("label", [_vm._v("Telefone fixo")]),
                _vm._v(" "),
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.phone,
                      expression: "phone"
                    }
                  ],
                  staticClass: "form-control",
                  attrs: { type: "text" },
                  domProps: { value: _vm.phone },
                  on: {
                    input: function($event) {
                      if ($event.target.composing) {
                        return
                      }
                      _vm.phone = $event.target.value
                    }
                  }
                })
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "form-group col-sm" }, [
                _c("label", [_vm._v("Telefone móvel")]),
                _vm._v(" "),
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.celphone,
                      expression: "celphone"
                    }
                  ],
                  staticClass: "form-control",
                  attrs: { type: "text" },
                  domProps: { value: _vm.celphone },
                  on: {
                    input: function($event) {
                      if ($event.target.composing) {
                        return
                      }
                      _vm.celphone = $event.target.value
                    }
                  }
                })
              ])
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "row" }, [
              _c("div", { staticClass: "form-group col-sm" }, [
                _c("label", [_vm._v("Endereço")]),
                _vm._v(" "),
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.address,
                      expression: "address"
                    }
                  ],
                  staticClass: "form-control",
                  attrs: { type: "text" },
                  domProps: { value: _vm.address },
                  on: {
                    input: function($event) {
                      if ($event.target.composing) {
                        return
                      }
                      _vm.address = $event.target.value
                    }
                  }
                })
              ])
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "row" }, [
              _c("div", { staticClass: "form-group col-sm" }, [
                _c("label", [_vm._v("Bairro")]),
                _vm._v(" "),
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.hood,
                      expression: "hood"
                    }
                  ],
                  staticClass: "form-control",
                  attrs: { type: "text" },
                  domProps: { value: _vm.hood },
                  on: {
                    input: function($event) {
                      if ($event.target.composing) {
                        return
                      }
                      _vm.hood = $event.target.value
                    }
                  }
                })
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "form-group col-sm" }, [
                _c("label", [_vm._v("Cidade")]),
                _vm._v(" "),
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.city,
                      expression: "city"
                    }
                  ],
                  staticClass: "form-control",
                  attrs: { type: "text" },
                  domProps: { value: _vm.city },
                  on: {
                    input: function($event) {
                      if ($event.target.composing) {
                        return
                      }
                      _vm.city = $event.target.value
                    }
                  }
                })
              ])
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "row" }, [
              _c("div", { staticClass: "form-group col-sm" }, [
                _c("label", [_vm._v("País")]),
                _vm._v(" "),
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.country,
                      expression: "country"
                    }
                  ],
                  staticClass: "form-control",
                  attrs: { type: "text" },
                  domProps: { value: _vm.country },
                  on: {
                    input: function($event) {
                      if ($event.target.composing) {
                        return
                      }
                      _vm.country = $event.target.value
                    }
                  }
                })
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "form-group col-sm" }, [
                _c("label", [_vm._v("CEP")]),
                _vm._v(" "),
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.cep,
                      expression: "cep"
                    }
                  ],
                  staticClass: "form-control",
                  attrs: { type: "text" },
                  domProps: { value: _vm.cep },
                  on: {
                    input: function($event) {
                      if ($event.target.composing) {
                        return
                      }
                      _vm.cep = $event.target.value
                    }
                  }
                })
              ])
            ])
          ])
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "row" }, [
        _c("div", { staticClass: "col-md-4" }, [
          _c(
            "button",
            {
              staticClass: "btn",
              on: {
                click: function($event) {
                  $event.stopPropagation()
                  $event.preventDefault()
                  return _vm.save()
                }
              }
            },
            [_vm._v("Salvar Alterações")]
          )
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "col-md-8" }, [
          _vm.showMsg
            ? _c(
                "div",
                {
                  staticClass: "alert alert-danger alert-dismissible fade show",
                  attrs: { role: "alert" }
                },
                [
                  _vm._v("\n          " + _vm._s(_vm.msg) + "\n          "),
                  _c(
                    "button",
                    {
                      staticClass: "close",
                      attrs: {
                        type: "button",
                        "data-dismiss": "alert",
                        "aria-label": "Fechar"
                      },
                      on: {
                        click: function($event) {
                          $event.stopPropagation()
                          $event.preventDefault()
                          return _vm.hideMessage()
                        }
                      }
                    },
                    [
                      _c("span", { attrs: { "aria-hidden": "true" } }, [
                        _vm._v("×")
                      ])
                    ]
                  )
                ]
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.showSuccessMsg
            ? _c(
                "div",
                {
                  staticClass:
                    "alert alert-success alert-dismissible fade show",
                  attrs: { role: "alert" }
                },
                [
                  _vm._v(
                    "\n          " + _vm._s(_vm.successMsg) + "\n          "
                  ),
                  _c(
                    "button",
                    {
                      staticClass: "close",
                      attrs: {
                        type: "button",
                        "data-dismiss": "alert",
                        "aria-label": "Fechar"
                      },
                      on: {
                        click: function($event) {
                          $event.stopPropagation()
                          $event.preventDefault()
                          return _vm.hideMessage()
                        }
                      }
                    },
                    [
                      _c("span", { attrs: { "aria-hidden": "true" } }, [
                        _vm._v("×")
                      ])
                    ]
                  )
                ]
              )
            : _vm._e()
        ])
      ])
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-md-4" }, [
      _c("h4", [_vm._v("Gestor")]),
      _vm._v(" "),
      _c("span", [
        _vm._v("Preencha com os dados do gestor de sua Organização Social.")
      ]),
      _vm._v(" "),
      _c("span", [
        _vm._v(
          "Esses dados devem coincidir com os dados bancários e cadastro nos meios de pagamento (Paypal e Pagseguro)."
        )
      ])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-19733682", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-19733682","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/manage-project/Manager.vue
// module id = null
// module chunks = 